"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errs = void 0;
const tslib_1 = require("tslib");
exports.errs = (0, tslib_1.__importStar)(require("./errors"));
